
import { memo } from "react"
const Line = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M21.7629 6.26572L14.1943 15.6257L9.03428 10.9371L2.89714 18.2743L2.24571 17.7257L8.94857 9.70286L14.0914 14.3743L21.0943 5.74286L21.7629 6.27429V6.26572Z"
                fill="currentColor"/>
        </svg>
    )
}

export default memo(Line)